// FOC-492 — Store en memoria del token temporal de verificación de dispositivo.
//
// El token temporal (purpose="device_verification") vive SOLO en memoria por
// diseño: una recarga de la página o cerrar la pestaña lo pierden a propósito,
// porque la verificación es sensible y no debe sobrevivir al refresh. Nunca
// se guarda en localStorage, sessionStorage, cookies ni ningún otro storage
// persistido.
//
// API:
//   startVerification(data)   — inicia la verificación con los datos que vinieron
//                               del 403 DEVICE_VERIFICATION_REQUIRED del login.
//   getVerification()         — devuelve la verificación actual si está vigente,
//                               o null si venció / nunca empezó.
//   getVerificationToken()    — atajo para installDpop.getToken: devuelve el
//                               token si la verificación está vigente.
//   markResent()              — resetea el countdown del reenvío a 60s.
//   clearVerification()       — borra el estado (al verificar OK, al volver
//                               al login, al bloquearse la cuenta o al vencer).

const RESEND_DELAY_MS = 60_000

let pending = null

export const startVerification = (data) => {
  const now = Date.now()
  pending = {
    token: data.verificationToken,
    maskedEmail: data.maskedEmail,
    expiresAt: now + data.expiresIn * 1000,
    resendAt: data.resendAvailableAt ?? now + RESEND_DELAY_MS
  }
}

export const getVerification = () => {
  if (!pending) return null
  if (Date.now() >= pending.expiresAt) {
    pending = null

    return null
  }

  return pending
}

export const getVerificationToken = () => {
  const v = getVerification()

  return v ? v.token : null
}

export const markResent = () => {
  if (pending) pending.resendAt = Date.now() + RESEND_DELAY_MS
}

export const clearVerification = () => {
  pending = null
}
